import { Component, Input, OnInit, Output, EventEmitter, ViewChild, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { EventsTriggerObject } from '../../../models/events-trigger';
import { CommonBeatsDialogComponent } from '../popups/common-beat-popups/common-beats-dialog.component';
import { FilterListModel } from '../../../models/filter-list-model';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { FormsService } from 'src/app/services/Forms/forms.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, skip } from 'rxjs/operators';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';
import { MagicSearchService } from 'src/app/services/magic-search/magic-search.service';
import { AdvancedFilterModel, MagicSearchModel, stemsEQModel } from 'src/app/models/magic-search.model';
import { DEFAULT_STEMS } from 'src/app/constants/magic-search.constants';
export  interface sortListObject {
  name: string,
  id: string;
  key:string
}

@Component({
  selector: 'ipm-filter-section',
  templateUrl: './filter-section.component.html',
  styleUrls: ['./filter-section.component.scss']
})
export class FilterSectionComponent implements OnInit, OnDestroy {
  listViewType: string = "list";
  @Input() isShowFilterOptions: boolean = false;
  /** Pin the filter row under the header while the page scrolls (All Beats page) */
  @Input() stickyOnScroll: boolean = false;
  @Input() isShowSearch: boolean = true;
  @Input() isShowSort: boolean = false;
  @Input() selectedSort: sortListObject;
  @Input() geneFilterList: Array<any> = [];
  @Input() isShowLayoutChange: boolean = true;
  selectedSortedData: any = {};
  isShowSelectedFilterSection: boolean =  false;
  isShowSearchSection: boolean =  false;
  stortingList: Array<sortListObject> = [];
  beatFilterList: any;
  updateFilters = new Subject<string>();
  selectedSortingFilter: any;
  @Input() isComponentType: any = "";
  @Input() searchPlaceholder: string = 'Search beats, producers and ..';
  @Input() showSearchModeToggle: boolean = false;
  @Input() mode: 'classic' | 'magic' = 'classic';
  @Input() filterOptionList: FilterListModel[] | null = null;
  @Output() filterOptionListChange = new EventEmitter<FilterListModel[]>();

  @Input() magicInitialPayload: MagicSearchModel | null = null;
  @Output() magicSearchRequest = new EventEmitter<MagicSearchModel>();
  @Output() magicResetRequest = new EventEmitter<void>();
  @Output() magicFiltersChange = new EventEmitter<AdvancedFilterModel>();

  stems: stemsEQModel = { ...DEFAULT_STEMS, levels: { ...DEFAULT_STEMS.levels } };
  eqEnabled = true;
  private stemsEqSubscription: Subscription;

  magicHasLyrics = false;
  magicAudioName: string | null = null;
  isAudioPlaying = false;
  private attachmentsStateSubscription: Subscription;
  private audioPlayingSubscription: Subscription;

  @ViewChild(CommonBeatsDialogComponent) sharedDialog : CommonBeatsDialogComponent;
  @Output() onEventTrigger: EventEmitter<EventsTriggerObject> = new EventEmitter();

  constructor(private router: Router,
    private routerActivate: ActivatedRoute,
    public commonService: CommonService,
    public ga4Tracking: Ga4trackingService,
    public formService: FormsService,
    public browserService: BrowserStorageService,
    public magicSearchService: MagicSearchService) {
    this.commonService.beatView.subscribe(view => {
      this.listViewType = view;
    })
    this.createSortList();
  }

  onSearchModeChange(mode: 'classic' | 'magic'): void {
    this.magicSearchService.setSearchMode(mode);
  }

  /**
   * Falls back to the global filter list only when no `filterOptionList` input is
   * bound — legacy classic consumers never set it, Magic passes its own array.
   */
  get resolvedFilterOptionList(): FilterListModel[] {
    return this.filterOptionList ?? this.commonService.filterOptionList;
  }

  /**
   * Classic derives this from route params (set in ngOnInit). Magic ignores that
   * flag entirely — the host page's URL may carry unrelated query params that
   * would otherwise latch this permanently true — and shows the tag/clear-filter
   * row only while one of its own filters is actually active.
   */
  get shouldShowSelectedFilterSection(): boolean {
    if (this.mode === 'magic') {
      return this.hasAnyMagicFilterActive;
    }
    return this.isShowSelectedFilterSection;
  }

  private get hasAnyMagicFilterActive(): boolean {
    if (!this.filterOptionList) return false;
    return this.filterOptionList.some(f => {
      if (f.filter_type === 'multiselect') return (f.filter_selected_values?.length ?? 0) > 0;
      if (f.filter_type === 'menu') return !!f.isFilterApplied;
      return false;
    });
  }

  get stemActiveCount(): number {
    return Object.values(this.stems?.levels ?? {}).filter(v => v !== 0).length;
  }

  onStemsChange(stems: stemsEQModel): void {
    this.stems = stems;
    this.magicSearchService.setStemsEq(this.stems, this.eqEnabled);
  }

  onEqEnabledChange(enabled: boolean): void {
    this.eqEnabled = enabled;
    this.magicSearchService.setStemsEq(this.stems, this.eqEnabled);
  }

  createSortList() {
    this.stortingList.push({
      name:"Price: High to Low",
      id:"1",
      key:"price_desc"
    },{
      name:"Price: Low to High",
      id:"2",
      key:"price_asc"
    },{
      name:"Sort by: For you",
      id:"3",
      key:"one_scroll_algo"
    },{
      name:"Sort by: Latest",
      id:"4",
      key:"recent_beats"
    });
  }
  ngOnInit(): void {
    setTimeout(() => {
      this.routerActivate.queryParams.subscribe((params:Params) => {
        this.isShowSelectedFilterSection =  Object.keys(params).length > 0 ? true : false;
        if (params['sV']) {
          this.isShowSearchSection = true;
        }
      });
    });

    this.updateFilters.pipe(
      debounceTime(500))
      .subscribe(value => {
        this.searchEventTrigger('', 'filter');
    });

    this.stemsEqSubscription = this.magicSearchService.stemsEq$.pipe(skip(1)).subscribe(({ stems, eqEnabled }) => {
      if (stems === this.stems && eqEnabled === this.eqEnabled) return;
      this.stems = stems;
      this.eqEnabled = eqEnabled;
    });

    this.attachmentsStateSubscription = this.magicSearchService.attachmentsState$.subscribe(({ hasLyrics, audioName }) => {
      this.magicHasLyrics = hasLyrics;
      this.magicAudioName = audioName;
    });

    this.audioPlayingSubscription = this.magicSearchService.audioPlayingState$.subscribe(isPlaying => {
      this.isAudioPlaying = isPlaying;
    });
  }

  /**
   * in this function update the view
   * like grid and list view and trigger the event
   * for update the value in the parent component
   * @param $event
   */
  onChangeView($event: any) {
    this.listViewType = $event;
    this.browserService.setBeatViewType(this.listViewType);
    this.commonService.beatView.next(this.listViewType);
  }

  /**
   * In this function search event trigger
   * @param event
   * @param type
   */
  searchEventTrigger(event: any, type: string) {
    if (type === "filter") {
      if (this.filterOptionList) {
        this.syncMagicMenuFiltersApplied();
        this.filterOptionListChange.emit(this.filterOptionList);
        return;
      }
      this.commonService.sendSearchDataUrl(event?.target?.value, type, this.isComponentType);
      const eventName = `filter_apply`;

      let attribute = {
        Category: 'Filter',
        Action: 'Apply',
        selected_Value: event.itemValue.key,

        userId: this.browserService?.getUserId() || 'guest',
        userRole: this.browserService?.getCurrentRoles() || 'guest',
        label: 'search',
      };

      this.ga4Tracking.sendEvent(eventName, attribute);
    } else {
      this.commonService.sendSearchDataUrl(event?.target?.value, type , this.isComponentType);
    }
  }

  /**
   * in this function open mobile view filter
   */
  openMobileViewFilter() {
    this.sharedDialog.openFilterDialog(this.resolvedFilterOptionList);
  }

  /**
   * Open mobile filter popup with a specific tab pre-selected.
   * @param tabIndex The index of the tab to pre-select inside the filter dialog.
   */
  openMobileFilterAtTab(tabIndex: number) {
    this.sharedDialog.openFilterDialogAtTab(this.resolvedFilterOptionList, tabIndex);
  }

  /**
   * Converts a global filterOptionList index to the corresponding p-tabView tab index
   * used inside filter-beat.component (which skips swipes-menu and swipes-menu-bpm-offer entries).
   */
  getMobileTabIndex(globalIndex: number): number {
    const list = this.resolvedFilterOptionList;
    let tabIndex = 0;
    for (let i = 0; i < globalIndex && i < list.length; i++) {
      const type = list[i]?.filter_type;
      if (type !== 'swipes-menu' && type !== 'swipes-menu-bpm-offer') {
        tabIndex++;
      }
    }
    return tabIndex;
  }

  getMenuRangeMax(filterOption: FilterListModel): number {
    return filterOption?.ApiFilterKey === 'tempo' ? 500 : 100000;
  }

  private menuRangeCache: { [filterId: string]: number[] } = {};

  getMenuRangeValues(filterOption: FilterListModel): number[] {
    const subRange = filterOption?.filter_sub_list?.[0];
    const start = +subRange?.starting_range || 0;
    const end = +subRange?.end_range || this.getMenuRangeMax(filterOption);
    const cached = this.menuRangeCache[filterOption.filter_id];
    if (cached && cached[0] === start && cached[1] === end) {
      return cached;
    }
    const range = [start, end];
    this.menuRangeCache[filterOption.filter_id] = range;
    return range;
  }

  onMenuRangeChange(filterOption: FilterListModel, values: number[]): void {
    filterOption.filter_sub_list[0].starting_range = String(values[0]);
    filterOption.filter_sub_list[0].end_range = String(values[1]);
    this.menuRangeCache[filterOption.filter_id] = values;
  }


  priceTypeOptions: Array<{ key: string, label: string }> = [
    { key: 'mp3', label: 'MP3' },
    { key: 'wav', label: 'WAV' },
    { key: 'stem', label: 'Stems' },
    { key: 'exclusive', label: 'Exclusive' },
  ];

  onPriceTypeChange(filterOption: FilterListModel, type: string): void {
    if (filterOption.selectedPriceType === type) return;
    filterOption.selectedPriceType = type;
    this.onChangeValue(null);
  }

  private syncMagicMenuFiltersApplied(): void {
    this.filterOptionList?.forEach(f => {
      if (f.filter_type === 'menu') {
        const max = f.ApiFilterKey === 'tempo' ? 500 : 100000;
        const start = +f.filter_sub_list[0].starting_range;
        const end = +f.filter_sub_list[0].end_range;
        f.filter_selected_values[0] = { ...f.filter_sub_list[0] };
        f.isFilterApplied = start > 0 || end < max;
      }
    });
  }

  /**
   * in this function reset the all filter values
   */
  ngOnDestroy(): void {
    this.commonService.resetFilter();
    this.stemsEqSubscription?.unsubscribe();
    this.attachmentsStateSubscription?.unsubscribe();
    this.audioPlayingSubscription?.unsubscribe();
  }

  /**
   * In this function remove date from tags
   *  list and update from list and url
   * @param type : string
   * @param index this is optional parameter number
   */
  isRemoveFilter(type: string, index?: number, swiperIndex?: number) {
    if (type === "search") {
      this.commonService.selectedSearchInputValue = "";
      this.commonService.sendSearchDataUrl(this.commonService.selectedSearchInputValue, type);
    } else {
      if (index !==  undefined &&  index  !== null) {
        let currentFilterObj: FilterListModel = this.resolvedFilterOptionList[index];
        if (currentFilterObj.filter_type === "multiselect") {
          currentFilterObj.filter_selected_values = [];
        } else if (currentFilterObj.filter_type === "menu"){
          currentFilterObj.filter_sub_list[0].end_range =  currentFilterObj.ApiFilterKey === "tempo" ?  "500" : "100000";
          currentFilterObj.filter_sub_list[0].starting_range = "0";
          currentFilterObj.filter_selected_values[0].starting_range = currentFilterObj.filter_sub_list[0].starting_range;
          currentFilterObj.filter_selected_values[0].end_range =  currentFilterObj.filter_sub_list[0].end_range;
        } else {
          if (swiperIndex !== undefined &&  swiperIndex !== null) {
            currentFilterObj.filter_sub_list[swiperIndex].isSelected = false;
          }
        }
        if (this.filterOptionList) {
          this.filterOptionList[index] = currentFilterObj;
          this.filterOptionListChange.emit(this.filterOptionList);
        } else {
          this.commonService.filterOptionList[index] = currentFilterObj;
          this.commonService.sendSearchDataUrl("", type, this.isComponentType);
        }
      }
    }
  }

  /**
   * in this function clear all the beats
   */
  clearAllFilter() {
    if (this.filterOptionList) {
      this.filterOptionList.forEach(f => {
        if (f.filter_type === 'multiselect') {
          f.filter_selected_values = [];
        } else if (f.filter_type === 'menu') {
          const max = f.ApiFilterKey === 'tempo' ? '500' : '100000';
          f.filter_sub_list[0].starting_range = '0';
          f.filter_sub_list[0].end_range = max;
          f.filter_selected_values[0] = { ...f.filter_sub_list[0] };
          f.isFilterApplied = false;
        }
      });
      this.filterOptionListChange.emit(this.filterOptionList);
      this.magicSearchService.requestClearQueryText();
      this.magicSearchService.requestRemoveAudio();
      this.magicSearchService.requestRemoveLyrics();
      return;
    }
    this.commonService.resetFilter();
    this.router.navigate([]);
  }

  onChangeValue($event: any) {
    this.updateFilters.next("");
  }

  onChangeSort(event: any) {
    if (event?.value && event?.value.key === "one_scroll_algo") {
      this.clearAllFilter();
    }
    this.onEventTrigger.emit({ event: "sort", data: event.value})
  }

  sortingEventTrigger(event: any) {
    if (event) {
      this.onEventTrigger.emit({ event: "sort", data: event})
    }
  }
}
